import { RenderMenuLinks } from './RenderMenuLinks'

export default RenderMenuLinks
